module.exports = __webpack_public_path__ + "media/images/logo-julaima-be07acec23c9e8b388a22ead29962d86.png";